<template>
  <div class="ly-card appointment-config">
    <el-button class="m-b-10" @click="setConfig" type="primary">设置配置</el-button>
    <table class="native-table">
      <tr>
        <th>活动时间</th>
        <th>预约开始时间</th>
        <th>预约结束时间</th>
        <th>剩余人数</th>
      </tr>
      <tr v-if="tableData.length === 0">
        <td colspan="4">暂无数据</td>
      </tr>
      <tr v-else v-for="item in tableData" :key="item.acitveTime">
        <td>{{ item.acitveTime }}</td>
        <td>{{ item.start_time }}</td>
        <td>{{ item.end_time }}</td>
        <td>{{ item.reserve_limit }}</td>
      </tr>
    </table>

    <el-dialog title="修改入园配置" :visible.sync="dialogVisible" width="800px">
      <ly-form :defaultFormItem="defaultFormItem" :formKeys="formKeys" ref="lyForm"> </ly-form>
      <div class="buttom">
        <el-button @click.native="addSubmit" type="primary">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from 'element-ui';
import LyForm from '@/components/LyForm';
import { appointment_config } from '@/utils/communityFormConfig';
import cAppointment from '@/api/cAppointment';

export default {
  name: 'newsContentDetail',
  components: {
    LyForm,
    ElDialog: Dialog
  },
  data() {
    return {
      formKeys: appointment_config,
      defaultFormItem: {
        reserve_desc: '',
        time_config: []
      },
      tableData: [],
      dialogVisible: false
    };
  },
  mounted() {
    this.init();
  },
  computed: {},
  methods: {
    init() {
      this.search();
    },
    async search() {
      const resData = [];
      this.defaultFormItem.time_config = [];
      const res = await cAppointment.getAppointmentConfig();
      this.defaultFormItem.reserve_desc = res.data.reserve_desc;
      Object.keys(res.data).forEach(item => {
        if (item !== 'reserve_desc') {
          resData.push({ ...res.data[item], acitveTime: item });
        }
      });
      this.tableData = resData.sort(this.dateDate('acitveTime', true));
      const timeList = [];
      // eslint-disable-next-line array-callback-return
      this.tableData.map(item => {
        timeList.push(item.end_time.split(' ')[0]);
      });
      if (timeList.length !== 0) {
        this.defaultFormItem.time_config.push(timeList.sort()[0]);
        this.defaultFormItem.time_config.push(timeList.sort()[timeList.length - 1]);
        this.formData = this.defaultFormItem;
      }
    },
    setConfig() {
      this.dialogVisible = true;
    },
    async addSubmit() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        const parmas_Date = [];
        const start_date = new Date(data.time_config[0]).valueOf();
        const end_date = new Date(data.time_config[1]).valueOf();
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i <= (end_date - start_date) / 86400000; i++) {
          parmas_Date.push(this.setDate(new Date(start_date + i * 86400000)));
        }
        const tempParams = {
          ...data,
          reserve_time_config: parmas_Date
        };
        delete tempParams.time_config;
        const res = await cAppointment.appointmentConfig(tempParams);
        if (res) {
          this.$message.success(res.msg || '配置成功！');
          this.dialogVisible = false;
          this.search();
        }
      }
    },
    setDate(timeData) {
      const y = timeData.getFullYear();
      let m = timeData.getMonth() + 1;
      m = m < 10 ? `0${m}` : m;
      let d = timeData.getDate();
      d = d < 10 ? `0${d}` : d;
      return `${y}-${m}-${d}`;
    },
    dateDate(property, bol) {
      return (a, b) => {
        const value1 = a[property];
        const value2 = b[property];
        if (bol) {
          return Date.parse(value1) - Date.parse(value2);
        }
        return Date.parse(value2) - Date.parse(value1);
      };
    }
  }
};
</script>
<style lang="less">
.appointment-config {
  .el-form-item {
    display: flex;
  }
  .ly-form .el-input__inner {
    width: 220px;
  }
  .ly-form .el-date-editor {
    width: 300px;
  }
  .ly-form .content-width-full {
    .el-form-item {
      width: 100%;
      .el-form-item__content {
        width: 100%;
      }
    }
  }
  .el-textarea__inner {
    width: 600px;
  }
}
</style>
